// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import {
  p, pb, px, pt, mx, py, mt, my
} from 'styled-components-spacing';
import { StyledWhatsappButton } from '@styles/buttons';
import theme from '@lib/theme';

export const StyledTrioWrapper = styled.div`
  ${mt(5)}
  background-color: ${theme.colors.lightGray3};
  ${py(2)};
`;

export const StyledCover = styled.div`
  margin-left: auto;
  margin-right: auto;
  overflow: visible;
  max-width: 1000px;
  background-color: #EEFCFF;

  z-index: 50;

  ${breakpoint('mobile', 'tablet')`
    min-height: unset;
  `}
  @media (min-width:500px) and (max-width:736px){
    max-width:500px;
    margin:auto;
  }
  @media (min-width:800px) and (max-width:1024px){
    max-width:800px;
    margin:auto;
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  ${px(3)}
  ${pt(3)}
  ${pb(3)}
  ${mt(4)}
  ${breakpoint('desktop')`
    ${p(3)}
  `}

  ${breakpoint('mobile', 'tablet')`
    margin-top: 0px;
  `}
`;

export const StyledContactButton = styled(StyledWhatsappButton)`
  background-color:#287FB0 !important;
  margin-top: 2rem;
  margin-bottom: 1rem;
  border-radius: 10px;
  pointer: cursor;
  svg{
    height: 30px;
    width: 30px;
  }
  ${breakpoint('mobile', 'tablet')`
    display: flex;
    align-items: center;
    padding: 6px;
    ${my(2)}
    margin-top: 0.75rem;
    border-radius: 5px;
    svg{
      height:13px;
      width:13px;
      margin-right:5px;
    }
  `}
   @media(min-width: 400px) and (max-width:736px) {
    padding: 8px;
  }
  ${breakpoint('tablet', 'desktop')`
    margin-top:1rem;  
    padding:10px;
    svg{
      height:25px;
      width:25px;
      margin-right:10px;
    }
  `}
  @media(max-width: 240px) {
    padding: 5px;
    margin-top: 2rem;
  }

  ${breakpoint('desktop')`
    padding: 10px;
  `}

  &:hover{
    transform: scale(0.95);
    transition: 0.3s;
  }
`;

export const StyledConnectMessage = styled.div`
  /* display: flex;
  flex-direction: column;
  justify-content: center; */
  font-size: 25px;
  font-weight: 600;

  ${breakpoint('mobile', 'tablet')`
    font-size: 16px;
  `}

  ${breakpoint('tablet', 'desktop')`
    font-size: 22px;
  `}

  @media (min-width: 400px) and (max-width:736px) {
    font-size: 15px;
  }
`;

export const BannerRightManComponent = styled.div`
height: 300px;
  img{
    width: -webkit-fill-available;
    height: 300px;
    border-radius: 10px;
  }
  ${breakpoint('tablet', 'desktop')`
      height:200px;
      img{
        height:200px;
      }
  `}
  @media and (min-width:1024px) and (max-width:1245px){
    height:250px;
    svg{
      height: 250px;
    }
  }
`;

export const ConnectMessage = styled.div`
  ${pt(3)}
  font-size: 30px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0em;
  color: #3471ab;
  width: 90%;

  @media (max-width: 1200px) {
    font-size: 30px;
    line-height: 1.2;
  }

  ${breakpoint('mobile', 'tablet')`
    font-size: 17px;
    line-height: 1.2;
    margin-bottom:0.75rem;
  `}

  ${breakpoint('tablet', 'desktop')`
    font-size: 25px;
    line-height: 1.2;
  `}

 @media(min-width: 400px) and (max-width:736px) {
    font-size: 20px;
  }
`;

export const StyledBannerSeperatorBlock = styled.div`
  width: 100%;
  background: linear-gradient(102.15deg, #ffffff 1.25%, #e0f3ff 99.19%);

  display: flex;
  justify-content: center;
  align-items: center;

  ${breakpoint('mobile', 'desktop')`
    margin-top: 0px;
  `}
`;

export const ConnectBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  ${breakpoint('mobile', 'desktop')`
    
  `}
`;

export const StyledBannerBlock = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  ${my(4)};
  align-items: stretch;
  /* position: relative; */
  background-color: white;
    box-shadow: rgb(114, 123, 142) 0px 2px 8px 0px;
    border-radius: 10px;
  /* background-color: #EEFCFF; */
  ${breakpoint('mobile', 'desktop')`
  width:auto;
    ${mx(3)}
  `}
`;

export const StyledMobileText = styled.div`
${py(2)}
font-size:15px;
line-height:1.2;
color:#136C9D;
${breakpoint('mobile', 'tablet')`
 font-size:15px;
 ${py(0)}
  `}

@media(min-width: 400px) and (max-width:736px) {
    font-size: 17px;
  }
`;

export const StyledBannerBottomLeft = styled.div`
  font-size: 28px;
  display: flex;
  padding: 30px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  ${breakpoint('mobile', 'desktop')`
    padding:15px;
  `} 
`;

export const StyledCardsMaxWidth = styled.div`
  max-width: 1200px;
  padding: 0 1rem;
  margin: auto;

  ${breakpoint('mobile', 'desktop')`
   padding: 0px;
  `}
`;

export const StyledHeading = styled.h1`
  font-size: 32px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 3rem;
  margin-top: 4rem;
  margin-left: 1rem;
  margin-right: 1rem;
  color: #136C9D;
  line-height: 1.2;
  ${breakpoint('mobile', 'tablet')`
    font-size: 25px;
    margin-top: 2rem;
    margin-bottom: 2rem;
    margin-top: 2rem;
  `}
`;

export const StyledViewMoreButton = styled.div`
  color: #136C9D;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 4px;
  :hover{
    cursor: pointer !important;
  }
  margin-top: 20px;
  margin-bottom: 20px;

  ${breakpoint('mobile', 'tablet')`
    margin-top: 0px;
  `}
  ${breakpoint('tablet', 'desktop')`
    margin: 0px;
  `}
  @media (min-width:1024px) and (max-width:1350px){
    margin: 0rem;
  }
`;

export const StyledWrapper = styled.div`
  display: flex;
  padding: 10px 20px;
  justify-content: flex-end;
  ${breakpoint('mobile', 'tablet')`
    justify-content: center;
  `}
`;

export const StyledSwiper = styled.div`
 .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets {
    bottom: 0px !important
  }

  .swiper-container-android .swiper-slide, .swiper-wrapper {
    margin-bottom: 2rem;
  }
`;
